// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"mca-z","subtitle":"nca-z","wrapper":"oca-z","leftArrow":"pca-z","rightArrow":"qca-z"};